jQuery( ( $ ) => {

	$( 'header' ).sticky( {
		zIndex: 2000,
	} );

	$( '.navbar-toggler' ).click( function() {
		if ( $( this ).hasClass( 'collapsed' ) ) {
			$( 'header' ).unstick();
		} else {
			$( '#header-menu' ).one( 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
				function(  ) {
					$( 'header' ).sticky( {
						zIndex: 2000,
					} );
					$( 'header' ).sticky( 'update' );
				} );
		}
	} );
} );